import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Package } from "lucide-react";
import ResourceInfo from "./ResourceInfo";
import "./ViewResource.css";

const ViewResource = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const resourceData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="resv-header-banner">
        <button type="button" className="resv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="resv-header-icon">
          <Package size={14} color="#fff" />
        </span>
        <div>
          <div className="resv-header-title">View Resource</div>
          <div className="resv-header-subtitle">Resource stock and deployment details</div>
        </div>
      </div>
      <ResourceInfo resourceData={resourceData} />
    </div>
  );
};

export default ViewResource;
